import React from 'react';
import style from '../storeChecksCopy.module.scss';
import cn from 'classnames';
import FullWidthModal from '../../common/Modal/FullWidthModal';
import { LABEL } from '../../../veriables';

const OpenTabCheckModal = ({
  isCounter,
  serverAppTheme,
  children,
  isTipOnlyEnabled,
  ...props
}) => {
  return (
    <FullWidthModal
      isOpen={props.isModalOpen}
      loading={props.loading}
      isModalCenter={true}
      style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}
      customClass={cn('h-100')}
      customClass2="h-100 w-100"
      customWidth={true}
      noBackground
    >
      <div className="col-12 p-0 justify-content-center align-items-center position-relative text-center h-100">
        <div
          className={cn('col-12 text-center fw-600 fs_18', style.moretitlebg)}
        >
          {isTipOnlyEnabled ? LABEL().TIP_ONLY : LABEL().ADD_TAB}
        </div>
        <div className="h-100">{children}</div>
      </div>
    </FullWidthModal>
  );
};

export default React.memo(OpenTabCheckModal);
